/** Canonical Generation Node width presets
 * (VISTOERA_CANVAS_GENERATION_NODE_CANONICAL_WIDTH_SYSTEM_P0_V1).
 *
 * Three stable Canvas geometry tiers — not browser viewport widths.
 * Expanded shells use these presets; collapsed generated-result states may
 * shrink-wrap the current result carrier (see canvasCollapsedResultFrameContract.ts). */

export type GenerationNodeSizePreset = 'compact' | 'standard' | 'wide'

export const GENERATION_NODE_WIDTH_PX = {
  compact: 460,
  standard: 520,
  wide: 620,
} as const

/** @deprecated Prefer `generationNodeWidthPx(nodeType)` — kept for image placement estimates. */
export const GENERATION_CARD_EXPANDED_WIDTH_PX = GENERATION_NODE_WIDTH_PX.standard

export const GENERATION_NODE_SIZE_PRESET_BY_TYPE: Record<string, GenerationNodeSizePreset> = {
  generate_creative: 'compact',
  generate_text: 'standard',
  generate_image: 'standard',
  generate_voice: 'standard',
  generate_voice_template: 'standard',
  generate_video: 'wide',
  storyboard_generation: 'wide',
  script_generation: 'standard',
  generate_tryon: 'standard',
  motion_reconstruction: 'wide',
  apparel_video_replication: 'wide',
}

export function generationNodeSizePreset(nodeType: string): GenerationNodeSizePreset {
  return GENERATION_NODE_SIZE_PRESET_BY_TYPE[nodeType] ?? 'standard'
}

export function generationNodeWidthPx(nodeType: string): number {
  return GENERATION_NODE_WIDTH_PX[generationNodeSizePreset(nodeType)]
}

/** Expanded shell uses the standard preset; collapsed hugs the result carrier (P0 frame contract). */
export function generationNodeCardWidth(nodeType: string): number {
  return generationNodeWidthPx(nodeType)
}

export function generationNodeWidthCssVar(preset: GenerationNodeSizePreset): string {
  return `var(--pcv-gen-width-${preset})`
}
